import {graphql} from 'gatsby'

import RentTemplate from './rent.template'

export const query = graphql`
  query ($limit: Int!, $skip: Int!) {
    products: allWpProduct(
      filter: {
        acf: {
          isforrent: {eq: true},
        },
      },
      limit: $limit,
      skip: $skip,
      sort: {fields: date, order: DESC},
    ) {
      edges {
        node {
          id
          name: title
          slug
          acf {
            isSold: issold
            isForSale: isforsale
            isForRent: isforrent
            addressNumber: addressnumber
            street {
              ... on WpStreet {
                name: title
              }
            }
            ward {
              ... on WpWard {
                name: title
              }
            }
            district {
              ... on WpDistrict {
                name: title
              }
            }
            province {
              ... on WpProvince {
                name: title
              }
            }
            directions {
              ... on WpDirection {
                name: title
              }
            }
            thumbnail {
              url: sourceUrl
              alt: altText
              mediaDetails {
                width
                height
              }
            }
            area
            numberOfBathrooms: numberofbathrooms
            numberOfBedrooms: numberofbedrooms
            price
          }
        }
      }
    }
  }
`

export default RentTemplate
